import React from 'react'
import { DataSmartphone } from 'components/Data/Data'
import { DownloadSmall } from 'components/Buttons/Buttons'
import { CallToAction } from 'components/Buttons/Buttons'

export default class Smartphone extends React.Component {
    render() {
        const Data = DataSmartphone()
        return (
            <section className="category-section decorative smartphone">

                <div className="centered">
                    <h3 className="section-title">{Data.smartphone.categoryName}</h3>
                    <p className="section-description">{Data.smartphone.categoryDescription}</p>
                    <div className="device-list smartphone">
                        <ul>
                            <li>
                                <figure>
                                    <img src={require("assets/images/smartphone/iphone6/iphone6-2up-blank.svg")} alt="Sketchize: iPhone 6 Wireframing Sheets" />
                                </figure>
                                <h4 className="item-title">
                                    <div className="title-inn">{Data.smartphone.up2.blank.title}</div>
                                </h4>
                                <p className="item-description">{Data.smartphone.up2.blank.description}</p>
                                <DownloadSmall link={require("assets/pdf/smartphone/iphone6/iphone6-2up-blank.pdf")} />
                            </li>
                            <li>
                                <figure>
                                    <img src={require("assets/images/smartphone/iphone6/iphone6-2up-expanded.svg")} alt="Sketchize: iPhone 6 Wireframing Templates" />
                                </figure>
                                <h4 className="item-title">
                                    <div className="title-inn">{Data.smartphone.up2.expanded.title}</div>
                                </h4>
                                <p className="item-description">{Data.smartphone.up2.expanded.description}</p>
                                <DownloadSmall link={require("assets/pdf/smartphone/iphone6/iphone6-2up-grid-expanded.pdf")} />
                            </li>
                            <li>
                                <figure>
                                    <img src={require("assets/images/smartphone/iphone6/iphone6-2up-dotted.svg")} alt="Sketchize: iPhone 6 Wireframing Sketch Sheets" />
                                </figure>
                                <h4 className="item-title">
                                    <div className="title-inn">{Data.smartphone.up2.dotted.title}</div>
                                </h4>
                                <p className="item-description">{Data.smartphone.up2.dotted.description}</p>
                                <DownloadSmall link={require("assets/pdf/smartphone/iphone6/iphone6-2up-grid.pdf")} />
                            </li>
                            <li>
                                <figure>
                                    <img src={require("assets/images/smartphone/iphone6/iphone6-3up-blank.svg")} alt="Sketchize: iPhone 6 Sketch Sheets" />
                                </figure>
                                <h4 className="item-title">
                                    <div className="title-inn">{Data.smartphone.up3.blank.title}</div>
                                </h4>
                                <p className="item-description">{Data.smartphone.up3.blank.description}</p>
                                <DownloadSmall link={require("assets/pdf/smartphone/iphone6/iphone6-3up-blank.pdf")} />
                            </li>
                            <li>
                                <figure>
                                    <img src={require("assets/images/smartphone/iphone6/iphone6-3up-dotted.svg")} alt="Sketchize: iPhone 6 Wireframing Templates" />
                                </figure>
                                <h4 className="item-title">
                                    <div className="title-inn">{Data.smartphone.up3.dotted.title}</div>
                                </h4>
                                <p className="item-description">{Data.smartphone.up3.dotted.description}</p>
                                <DownloadSmall link={require("assets/pdf/smartphone/iphone6/iphone6-3up-grid.pdf")} />
                            </li>
                        </ul>
                    </div>{/* .device-list */}

                    <CallToAction clickid="download-smartphone" link={"https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/smartphone.zip"} content="DOWNLOAD MORE" />

                </div>{/* .inn */}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MainSections/Smartphone/Smartphone.js